import { useAppAccess as useSharedAppAccess, type UseAppAccessResult } from "@scoutingops/security";

import { useSupabaseClient } from "@/hooks/use-supabase-client";

export type { UseAppAccessResult };

/**
 * Thin binding of @scoutingops/security's shared useAppAccess() to this app's
 * own useSupabaseClient() — same pattern as every other app in the platform.
 * Gates the Studio via AppAccessGuard; the unit's published public website is
 * served elsewhere and is not behind this.
 *
 * UI noise reduction, not enforcement: the real boundary is RLS, and every
 * unknown input here fails open. Signed out (or with no active org) the
 * underlying queries stay disabled and nothing is gated.
 */
export function useAppAccess(): UseAppAccessResult {
  const getSupabase = useSupabaseClient();
  return useSharedAppAccess(getSupabase);
}
